// Colunas do grid.
export const Columns = [
	{
		headerName: 'name',
		field: 'name',
		filter: true
	},
	{
		headerName: 'corporate_name',
		field: 'corporateName',
		filter: true,
		width: 200
	},
	{
		headerName: 'cnpj',
		field: 'document',
		filter: true,
		type: 'cnpj'
	},
	{
		headerName: 'phone',
		field: 'phone',
		width: 150
	},
	{
		headerName: 'email',
		field: 'email',
		filter: true,
		width: 200
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans',
		with: 130
	}
]